import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { CarrierFilters, CarrierSlice } from "./carriersTypes.ts";

const initialState: CarrierSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const carriersSlice = createSlice({
  name: "carriers",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<CarrierSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<CarrierSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof CarrierFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<CarrierSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  carriersSlice.actions;

export const selectPage = (state: RootState) => state.carriers.page;
export const selectRowsPerPage = (state: RootState) =>
  state.carriers.rowsPerPage;
export const selectFilter = (state: RootState) => state.carriers.filter;
export const selectSort = (state: RootState) => state.carriers.sort;

export default carriersSlice.reducer;
